const walletLedgerReducer = (state = {
    loading:false,
    ledgers:[],totalRecords:0
}, action) => {
    switch (action.type) {
        case "FETCH_LEDGER":
            return { ...state ,loading:true,ledgers:[],totalRecords:0}
        case "RECEIVE_LEDGER":
            return {...state, ledgers:[...action.payload.ledger],loading:false,totalRecords:action.payload.totalRecords}
        case "ERROR_LEDGER":
            return { ...state ,ledgers:[],loading:true,totalRecords:0}
        default:
            return { ...state }
    }
}

export default walletLedgerReducer;